export default __webpack_public_path__ + "static/media/menu-unfold.145efdaf.svg";